// extracted by mini-css-extract-plugin
export default {"container":"Models_container__b5fVr","block":"Models_block__7zSkF"};